/* Industry landing family — progressive enhancement only.
   Everything here is optional; the page is fully functional without JS. */
(function () {
  'use strict';

  // Defence in depth: ind-assets is only ever rendered once (by ind-hero),
  // but if a future edit duplicates the <script> tag, this stops a second
  // execution from attaching duplicate observers/listeners.
  if (window.__indLandingInit) return;
  window.__indLandingInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Stat count-up ------------------------------------------------- */
  function parseStat(raw) {
    // "15,000+" -> {target:15000, prefix:"", suffix:"+"}; "24-48hrs" -> null
    var m = /^(\D*)([\d,]+)(.*)$/.exec(raw.trim());
    if (!m) return null;
    var digits = m[2].replace(/,/g, '');
    if (!digits.length) return null;
    // A second number in the suffix means it is a range, not a single value.
    if (/\d/.test(m[3])) return null;
    return { prefix: m[1], target: parseInt(digits, 10), suffix: m[3], grouped: m[2].indexOf(',') > -1 };
  }

  function format(n, grouped) {
    return grouped ? n.toLocaleString('en-AU') : String(n);
  }

  function countUp(el) {
    var parsed = parseStat(el.getAttribute('data-ind-countup-raw') || el.textContent);
    if (!parsed) return;
    var duration = 1100, start = null;
    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = parsed.prefix + format(Math.round(parsed.target * eased), parsed.grouped) + parsed.suffix;
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-ind-countup]');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) return; // values already in the DOM
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        countUp(entry.target);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Hero background video ----------------------------------------- */
  // The clip is decorative motion. Under prefers-reduced-motion it must not
  // play, but hiding it would leave a bare navy panel where the banner's
  // right-hand side should be, so it is paused on its first frame instead.
  // Runs at script-execution time (the tag is deferred, so this is before
  // DOMContentLoaded) to stop playback as early as the DOM allows.
  function initHeroVideo() {
    if (!reduced) return;
    var videos = document.querySelectorAll('.ind-hero__media video');
    Array.prototype.forEach.call(videos, function (v) {
      v.autoplay = false;
      v.removeAttribute('autoplay');
      v.pause();
    });
  }

  function init() {
    initCountUp();
    initHeroVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
